import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { ITransaction, TransactionsDTO } from "./models";

export const TransactionsApi = async (dto: TransactionsDTO) => {
  const { data } = await api.post<ITransaction[]>(
    API_ROUTES.TRANSACTIONS,
    qs.stringify({ ...defaultOptions(), ...dto, transaction_type_id: 5 })
  );

  return data;
};
